"use client";

import type { FC } from "react";

import { isPreviewing } from "@builder.io/sdk-react";
import classNames from "classnames";

import { buildHeroContent, HeroBackground, HeroContent } from "@jti/ui/components/HeroV2";
import { useHeroHeightLock } from "@jti/ui/hooks/useHeroHeightLock";

import type { heroInputs } from "./HeroV2.builder";

export type HeroBannerProps = BuilderComponentProps<typeof heroInputs>;

export const Hero: FC<HeroBannerProps> = ({ data }) => {
  const { heroRef } = useHeroHeightLock();

  return (
    <div ref={heroRef}>
      <HeroBackground
        backgroundType={data.backgroundType}
        desktopImage={data.desktopImage}
        mediumImage={data.mediumImage}
        smallImage={data.smallImage}
        tabletVideoFileReference={data.tabletVideoFileReference}
        tabletVideoFileType={data.tabletVideoFileType}
        mobileVideoFileReference={data.mobileVideoFileReference}
        mobileVideoFileType={data.mobileVideoFileType}
        videoFileReference={data.videoFileReference}
        videoFileType={data.videoFileType}
        removeVideoRoundedCorners={true}
        imageClassName={classNames({
          "previewing-content": isPreviewing(),
        })}
        videoClassName={classNames({
          "previewing-content": isPreviewing(),
        })}
      />
      <div>
        <HeroContent
          {...buildHeroContent(data, false)}
          heroContentClassName={classNames({
            "previewing-content": isPreviewing(),
          })}
        />
        {/* TODO uncomment this when DS Hero will be merged */}
        {/* <div className={styles.bottom}>
          {hasDiscounts && (
            <Promotions
              discounts={discounts}
              legalDisclaimer={data.legalDisclaimer}
            />
          )}
        </div> */}
      </div>
    </div>
  );
};

export default Hero;
